// extracted by mini-css-extract-plugin
export default {"root":"EditListingLegalPanel_root__j8+4a","form":"EditListingLegalPanel_form__2a4V6","title":"EditListingLegalPanel_title__FUfNU"};